<template>
  <div class="min-h-screen flex flex-col">
    <Navbar />

    <main class="flex-1 max-w-4xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <Breadcrumbs :items="[{ label: 'Privacy Policy' }]" />
      
      <div class="card mt-6">
        <div class="p-8 prose dark:prose-invert max-w-none">
          <h1 class="text-4xl font-bold text-gray-900 dark:text-gray-100 mb-6">
            Privacy Policy
          </h1>
          
          <p class="text-sm text-gray-500 dark:text-gray-400 mb-8">
            Last updated: {{ new Date().toLocaleDateString() }}
          </p>

          <div class="space-y-6 text-gray-700 dark:text-gray-300">
            <section>
              <h2 class="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-4">1. Introduction</h2>
              <p>
                Neutral Fuels LLC ("we", "us", or "our") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our Customer Portal.
              </p>
            </section>

            <section>
              <h2 class="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-4">2. Information We Collect</h2>
              <p>We collect information that you provide directly to us, including:</p>
              <ul class="list-disc pl-6 mt-2 space-y-1">
                <li>Personal identification information (Name, email address, phone number)</li>
                <li>Account credentials</li>
                <li>Company information</li>
                <li>Transaction data</li>
                <li>Usage data and analytics</li>
              </ul>
            </section>

            <section>
              <h2 class="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-4">3. How We Use Your Information</h2>
              <p>We use the information we collect to:</p>
              <ul class="list-disc pl-6 mt-2 space-y-1">
                <li>Provide, maintain, and improve our services</li>
                <li>Process transactions and send related information</li>
                <li>Send technical notices and support messages</li>
                <li>Respond to your comments and questions</li>
                <li>Monitor and analyze trends, usage, and activities</li>
                <li>Detect, prevent, and address technical issues</li>
              </ul>
            </section>

            <section>
              <h2 class="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-4">4. Data Security</h2>
              <p>
                We implement appropriate technical and organizational measures to protect your personal data against unauthorized or unlawful processing, accidental loss, destruction, or damage. These measures include:
              </p>
              <ul class="list-disc pl-6 mt-2 space-y-1">
                <li>Encryption of data in transit and at rest</li>
                <li>Regular security assessments</li>
                <li>Access controls and authentication</li>
                <li>Regular backups</li>
              </ul>
            </section>

            <section>
              <h2 class="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-4">5. Data Retention</h2>
              <p>
                We retain your personal information for as long as necessary to fulfill the purposes outlined in this Privacy Policy, unless a longer retention period is required or permitted by law.
              </p>
            </section>

            <section>
              <h2 class="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-4">6. Your Rights</h2>
              <p>You have the right to:</p>
              <ul class="list-disc pl-6 mt-2 space-y-1">
                <li>Access your personal data</li>
                <li>Correct inaccurate personal data</li>
                <li>Request deletion of your personal data</li>
                <li>Object to processing of your personal data</li>
                <li>Request restriction of processing your personal data</li>
                <li>Request transfer of your personal data</li>
              </ul>
            </section>

            <section>
              <h2 class="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-4">7. Third-Party Services</h2>
              <p>
                We may employ third-party companies and individuals to facilitate our Service, provide the Service on our behalf, or assist us in analyzing how our Service is used. These third parties have access to your personal information only to perform these tasks on our behalf.
              </p>
            </section>

            <section>
              <h2 class="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-4">8. Changes to This Privacy Policy</h2>
              <p>
                We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last updated" date.
              </p>
            </section>
          </div>

          <div class="mt-8 pt-6 border-t border-gray-200 dark:border-gray-700">
            <p class="text-sm text-gray-500 dark:text-gray-400">
              If you have any questions about this Privacy Policy, please contact us at:
            </p>
            <p class="text-sm text-gray-700 dark:text-gray-300 mt-2">
              <strong>Email:</strong> privacy@neutralfuels.net<br />
              <strong>Phone:</strong> +971 4 234 5678<br />
              <strong>Address:</strong> Suite 415, Liberty House, DIFC, Dubai, UAE
            </p>
          </div>
        </div>
      </div>
    </main>

    <Footer />
  </div>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue'
import Footer from '@/components/Footer.vue'
import Breadcrumbs from '@/components/ui/Breadcrumbs.vue'
</script>
